var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-form",
        { ref: "tc_form" },
        [
          _c("v-text-field", {
            staticClass: "d-inline-flex",
            class: _vm.dense ? "grv-input-dense" : "grv-input",
            staticStyle: { width: "160px" },
            attrs: {
              name: _vm.param.name,
              rules: _vm.rules,
              mask: _vm.is_drop_frame ? "##:##:##;##" : "##:##:##:##",
              readonly: _vm.readonly
            },
            on: {
              "update:error": function($event) {
                _vm.errored = $event
              },
              change: function($event) {
                return _vm.emitValue()
              }
            },
            scopedSlots: _vm._u([
              {
                key: "label",
                fn: function() {
                  return [_c("Label", { attrs: { param: _vm.param } })]
                },
                proxy: true
              },
              {
                key: "append",
                fn: function() {
                  return [
                    _c(
                      "v-btn",
                      {
                        staticClass: "d-inline-flex ma-0",
                        attrs: {
                          flat: "",
                          icon: "",
                          disabled:
                            _vm.tc === _vm.tc_default &&
                            _vm.fps === _vm.fps_default
                        },
                        on: {
                          click: function($event) {
                            return _vm.raz()
                          }
                        }
                      },
                      [_c("v-icon", [_vm._v("close")])],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ]),
            model: {
              value: _vm.tc,
              callback: function($$v) {
                _vm.tc = $$v
              },
              expression: "tc"
            }
          }),
          _vm._v(" "),
          _c("v-autocomplete", {
            staticClass: "d-inline-flex",
            class: _vm.dense ? "grv-input-dense" : "grv-input",
            staticStyle: { width: "170px" },
            attrs: {
              items: _vm.fps_enum,
              rules: _vm.rules,
              "menu-props": { contentClass: "grv-menu" },
              prefix: "@",
              readonly: _vm.readonly
            },
            on: {
              change: function($event) {
                return _vm.emitValue()
              }
            },
            model: {
              value: _vm.fps,
              callback: function($$v) {
                _vm.fps = $$v
              },
              expression: "fps"
            }
          }),
          _vm._v(" "),
          _c("span", { staticClass: "d-inline-flex" }, [
            _vm._v(_vm._s(_vm.value))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("Hint", { attrs: { param: _vm.param, errored: _vm.errored } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7188cef0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7188cef0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/fields/timecode.vue
// module id = null
// module chunks = 